import {
  PredicateModel,
  SortDescriptorModel,
} from "@syncfusion/ej2-react-grids";
import { indexOf, sortBy } from "lodash";
import GridColumn from "../../../../GridColumns/GridColumn";
import GridViewReadDTO from "./GridViewReadDTO";

export default class GridView {
  public id: string;
  public gridId: string;
  public title: string;
  public columnSettings: string[];
  public filterSettings?: string;
  public sortSettings?: string;
  public metricSettings?: string;

  public columnConfiguration: GridColumn[];
  public filterConfiguration?: PredicateModel[];
  public sortConfiguration?: SortDescriptorModel[];
  public metricConfiguration: string[];

  constructor(
    gridViewReadDTO: GridViewReadDTO,
    baseGridColumnsConfiguration: GridColumn[]
  ) {
    this.id = gridViewReadDTO.id;
    this.gridId = gridViewReadDTO.gridId;
    this.title = gridViewReadDTO.title;
    this.columnSettings = gridViewReadDTO.columnSettings;
    this.filterSettings = gridViewReadDTO.filterSettings;
    this.sortSettings = gridViewReadDTO.sortSettings;
    this.metricSettings = gridViewReadDTO.metricSettings;

    // Compute
    this.columnConfiguration = this.getColumnConfiguration(
      this.columnSettings,
      baseGridColumnsConfiguration
    );
    this.filterConfiguration = this.getFilterConfiguration(
      this.columnConfiguration
    );
    this.sortConfiguration = this.getSortConfiguration(
      this.columnConfiguration
    );

    this.metricConfiguration = this.getMetricConfiguration();
  }

  private getMetricConfiguration(): string[] {
    return this.metricSettings ? this.metricSettings.split(",") : [];
  }

  private getColumnConfiguration(
    columnSettings: string[],
    baseGridColumnsConfiguration: GridColumn[]
  ): GridColumn[] {
    // Return default if corrupted
    if (!columnSettings || columnSettings.length <= 0) {
      return {
        ...(baseGridColumnsConfiguration as GridColumn[]),
      };
    }

    let config = baseGridColumnsConfiguration.filter((x) =>
      columnSettings?.find((y) => x.field === y)
    );

    config = sortBy(config, function (col) {
      return indexOf(columnSettings, col.field);
    });

    return config;
  }

  private getFilterConfiguration(
    establishedColumnsConfiguration: GridColumn[]
  ): PredicateModel[] {
    if (!this.filterSettings) {
      return [];
    }

    let config = JSON.parse(this.filterSettings) as PredicateModel[];
    config = config.filter((x) =>
      establishedColumnsConfiguration?.find((y) => x.field === y.field)
    );

    return config;
  }
  public getSortConfiguration(
    establishedColumnsConfiguration: GridColumn[]
  ): SortDescriptorModel[] {
    if (!this.sortSettings) {
      return [];
    }

    let config = JSON.parse(this.sortSettings) as SortDescriptorModel[];
    config = config.filter((x) =>
      establishedColumnsConfiguration?.find((y) => x.field === y.field)
    );

    return config;
  }
}
